export { default as ComposerDockProductItem } from './ComposerDockProductItem';
export type { ComposerDockProductItemProduct } from './ComposerDockProductItem';
